<template>
	<div class="aboutcom">
		<div class="comtop">
			<img src="../../static/img/congtactus.png"/>
				<div class="com-tit">
				<span>
					<img src="../../static/img/contactusicon.png"/><b>联系我们</b>
				</span>
				<p>拥有专业的售后服务团队，秉承“优质、高效，用心服务”的<br />
服务理念，不断提高客户的满意度</p>
			</div>
		</div>
	
		<div class="com-detail">
			<div class="com-top-top">
				<h4>联系我们</h4>
				<div class="com-line">
				</div>
				
			</div>
			<!--
            	描述：公司简介
           -->
            <div class="cominfo">
				<h4 class="small-tit">联系我们</h4>
				<img src="../../static/img/ding2.png"/><br />
				<img src="../../static/img/ding3.png"/><br />
            </div>
            
		</div>
	</div>
</template>

<script>
	export default{
		name : 'aboutcom',
		data(){
			return {
				top : [
				{id : 0 , imgsrc : 'static/img/aboutcom.jpg' , title : '关于我们'},
				],
				center : [
				{id : 0 , imgsrc : 'static/img/aboutcom.jpg' , title : '公司简介' , smalltit : '专业的信息化服务商'},
				{id : 1 , imgsrc : 'static/img/aboutcom.jpg' , title : '组织框架' , smalltit : '专业的信息化服务商'},
				{id : 2 , imgsrc : 'static/img/aboutcom.jpg' , title : '企业文化' , smalltit : '专业的信息化服务商'},
				{id : 3 , imgsrc : 'static/img/aboutcom.jpg' , title : '资质荣誉' , smalltit : '专业的信息化服务商'},
				{id : 4 , imgsrc : 'static/img/aboutcom.jpg' , title : '新闻资讯' , smalltit : '专业的信息化服务商'},
				],
				chalid : 0,
				comimg : [
				{id :　0　, imgsrc : 'static/img/comabout1.jpg'},
				{id :　1　, imgsrc : 'static/img/comabout2.jpg'},
				],
				wenhua :[
				{id : 0 , wentit : '责任感' , wencontent : '我们的企业要有社会责任感，我们的员工对公司、客户、家庭要勇于负责任'},
				{id : 1 , wentit : '团队精神' , wencontent : '我们的企业是一个团队，每个员工都必须充分认可团队、依靠团队、配合 团队、才能形成一个有战斗力的队伍'},
				{id : 2 , wentit : '专业服务、技术创新' , wencontent : '拥有专业的技术、良好的服务能力，展现IT行业的“工匠”精神'},
				{id : 3 , wentit : '管理的规范化与制度化' , wencontent : '我们相信：企业的长远发展需要管理的规范化与运营的制度化'},
				{id : 4 , wentit : '勤劳、诚实、自信、超越自我的精神' , wencontent : '我们希望我们的员工是一个勤奋、诚实可靠、有自信、勇于超越自我的人'},
				],
				honor :[
				{id : 0 , hoimg : 'static/img/zz1.jpg'},
				{id : 1 , hoimg : 'static/img/zz4.jpg'},
				{id : 2 , hoimg : 'static/img/zz5.jpg'},
				{id : 3 , hoimg : 'static/img/zz6.jpg'},
				{id : 4 , hoimg : 'static/img/zz7.jpg'},
				{id : 5 , hoimg : 'static/img/zz8.jpg'},
				{id : 6 , hoimg : 'static/img/zz9.jpg'},
				{id : 7 , hoimg : 'static/img/zz10.jpg'}
				],
				honorname :[
				{id : 0 , honame : '■ 计算机信息系统集成企业资质证书叁级'},
				{id : 1 , honame : '■ 广东省公共安全技术防范系统设计、施工、维修资格证（壹级）证书'},
				{id : 2 , honame : '■ 广东省涉密计算机、通信和办公自动化设备定点维护维修证书'},
				{id : 3 , honame : '■ 软件企业认定证书'},
				{id : 4 , honame : '■ ISO9001 2015质量管理体系认证证书'},
				{id : 5 , honame : '■ 高新技术企业证书'},
				{id : 6 , honame : '■ 音视频工程业企业资质贰级'},
				{id : 7 , honame : '■ 守合同重信用企业（连续九年）'}
				],
				scrollWatch: true
			}
		},
		mounted(){
			this.getID();
		},
		metaInfo: {
			title: '联系我们'
		},
		methods : {
			getID(){
				this.chalid = this.$route.params.ID
			},
		},
	}
</script>

<style>
	.aboutcom{
		position: relative;
		clear: both;
		width: 100%;
		margin: 0 auto;
	}
	.comtop{
		position: relative;
		width: 100%;
		clear: both;
	}
	.comtop img{
		width: 100%;
	}
	.com-detail{
		width: 80%;
		margin: 60px auto;
		position: relative;
		clear: both;
		text-align: left;
	}
	.com-detail h4{
		font-weight: 700;
		margin-left: 50px;
		font-size: 22px;
	}
	.com-line{
		width: 25px;
		height: 3px;
		position: absolute;
		background: #1975f0;
		border-radius: 4px;
		top: 8px;
	}
	.com-top-top{
		width: 100%;
		border-bottom: 1px solid #ddd;
		position: relative;
		padding-bottom: 10px;
		margin-bottom: 20px;
	}
	.com-detail h4.small-tit{
		text-align: center;
		width: 500px;
		margin: 0 auto;
		position: relative;
		color: #0066ef ;
		font-weight: 500;
	}
	.cominfo{
		position: relative;
		clear: both;
		padding: 2%;
	}
		.com-tit img {
	    width: 4% !important;
	    margin-right: 23px;
	}
	.com-tit{
		width: 40%;
		position: absolute;
		clear: both;
		z-index: 3;
		top: 12vw;
	    left: 11vw;
	    text-align: left;
	    font-size: 22px;
	    color: #fff;
	}
	.com-tit p{
		margin-top: 20px;
		font-size: 14px;
		line-height: 28px;
	}
	.com-tit b{
		font-size: 25px;
	    position: relative;
	    top: 3px;
	}
	.cominfo p{
		color: #666666;
		line-height: 35px;
		margin: 30px auto;
		font-size: 18px;
		text-indent:2em;
	}
	.cominfo img{
		text-align: center;
	}
	.imgcomab{
		width: 49%;
		position: relative;
		clear: both;
		display: inline-block;
		vertical-align: top;
		text-align: center;
	}
	.imgcomab img{
		width: 85%;
	}
	.singleimg,.singlewimg{
		width:100%;
		position: relative;
		margin: 0 auto;
		text-align: center;
	}
	.singleimg img{
		width: 75%;
	}
	.singlewimg img{
		width: 100%;
	}
	.comwenhua h3{
		color: #e03500;
		font-weight: 900;
		font-size: 22px;
	}
	.comwenhua p{
		text-indent:.5em;
	}
	.comwenhua span{
		color: #e03500;
	}
	.comwenhua{
		position: relative;
		margin-top: 45px;	
	}
	.wencom{
		position: relative;
		margin-top: 10px;
	}
	.honor{
		position: relative;
		width: 25%;
		clear: both;
		display: inline-block;
		margin: 20px auto;
		text-align: center;
	}
	.honor img{
		width: 85%;
   		height: 192px;
   		transition: .5s all;
	}
	.honor img:hover{
		transform: scale(1.1);
	}
</style>


// WEBPACK FOOTER //
// src/components/contactu.vue